import {MSP} from "./msp";
import {onMount} from "@otto-ec/global-resources/dom";
import {runWithSpan} from "@otto-ec/global-resources/apm";

onMount(".promo-msp__container", (element) => {
    runWithSpan(() => {
        new MSP(element);
    },   "ft3.promo-msp")
});